module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5AZf8"))).then(() => parcelRequire('hEqeo'));